import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './css/main.css';
import $ from 'jquery';
//import {useLocation } from "react-router-dom";
const initialPageInfo = {
  page: 'loading'
}
const ShoppingHistory = props => {
  //const location = useLocation();
  //const pageName = location.pathname;
  const callCustomerBackend = "https://" +  window.location.hostname + "/php/controllers/Customer.php";
  console.log(window.location.hostname)

  useEffect(() => {
    const post_data = {
      'function' : 'getOrdersForUser',
      "authToken" : props.user.signInUserSession.accessToken.jwtToken
    }
    axios.post(callCustomerBackend, post_data)
    .then(result => {
        //console.log(result.data)
        if (result.data.status === "200"){
          createOrderTable(result.data.content);
        }
        else{
          $('order_list div').html('Virhe tilauksia ladattaessa')
        }
    })
    .catch(error => function(){
      console.log('error:' + error)
      $('.order_list').html('Virhe tilauksia ladattaessa')
    })
  }, []);
  function createOrderTable(orderList){
    if (orderList.length > 0) {
      var htmlNotReady = '<div class="h2 orders_topic">Viimeisimmät tilaukset</div>'
      var htmlReady = '<div class="h2 orders_topic">Valmiit tilaukset</div>'
      orderList.forEach((order) =>{
        if (order.orderStatus === "VALMIS"){
          //htmlReady += '<table><tbody>'
          htmlReady += listItemCreator(order);
          //htmlReady += '</tbody></table>'
        }
        else {
          //htmlNotReady += '<table><tbody>'
          htmlNotReady += listItemCreator(order);
          //htmlNotReady += '</tbody></table>'
        }
        htmlNotReady += "</div>"
        htmlReady += "</div>"
        $('.order_list').html(htmlNotReady + htmlReady)
      })
    }
    else {
      var htmlNoOrders = '<div class="no_orders">Vanhoja tilauksia ei löytynyt.<br/>Ongelmatilanteissa ota yhteyttä tuki@ekukka.fi</div>';
      $('.order_list').html(htmlNoOrders)
    }
  }
  const capitalizeFirstLowercaseRest = str => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  function listItemCreator(data){
    //console.log(data);
    var shopURL = data.shopURL; 
    var receipt_rest_path = "/admin/order_receipt_print_customer.php?id=";
    var order_number_short_version = parseInt(data.fullOrderID.substring(4)); 
    var receipt_link = shopURL+receipt_rest_path+order_number_short_version+"&receipt="+data.linkURL;

    var ret = '<div class="order_history_container">'+
                '<div class="item_table q_side">'+

                  '<div class="q_a_container order_orderID font_16"><div class="info">Tilausnumero:</div><div class="answer">'+data.fullOrderID+'</div></div>'+
                  '<div class="q_a_container order_shop font_16"><div class="info">Liike:</div><div class="answer"><a href="'+data.shopURL+'" target="_blank" class="shoplink">'+data.shopName+'</a></div></div>'+
                  '<div class="q_a_container order_date font_16"><div class="info">Tilauksen päivämäärä:</div><div class="answer">'+data.orderCreatedTime+'</div></div>'+
                  '<div class="q_a_container order_delivery font_16"><div class="info">Tilauksen toimituspäivä:</div><div class="answer">'+data.targetDate+'</div></div>'+
                  '<div class="q_a_container order_status font_16"><div class="info">Tilauksen tilanne:</div><div class="answer">'+capitalizeFirstLowercaseRest(data.orderStatus)+'</div></div>'+
                  '<div class="q_a_container order_price font_16"><div class="info">Yhteensä:</div><div class="answer">'+(data.orderPrice.toFixed(2)).replace(".", ",")+' €</div></div>'+

                '</div>'+
                '<div class="item_table receipt_section">'+
                  '<div rowspan="6" class="bold"><span class="span_center">Tarkemmat tiedot</span><a href="'+receipt_link+'" target="_blank" class="recept_button">Kuitti</a></div>'+
                '</div>'+
              '</div>';
  

    return(ret);
  }
  const [pageInfo, updatePageInfo] = useState(initialPageInfo)
  return(
    <div className="content">
      <div className="breadcrumb"><div onClick={event => props.onChange('landing')}>Oma eKukka</div> &gt; Omat tilaukset </div>
      <div className="h1">Omat tilaukset</div>
      <div className="order_list">
      {
        pageInfo.page === 'loading' && (
          <div>Ladataan tilauksia</div>
        )
      }
      </div>
    </div>
  )
}
export default ShoppingHistory;
